import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkOrAWrapper = styled.div`
  text-decoration: none !important;

  a {
    text-decoration: none !important;
  }
`

type LinkOrAProps = {
  asLink: boolean
  to: string
  sameTab?: boolean
  style?: React.CSSProperties
}

const LinkOrA: React.FC<LinkOrAProps> = ({
  asLink,
  to,
  children,
  sameTab = false,
  style,
}) => (
  <LinkOrAWrapper style={style}>
    {asLink ? (
      <Link to={to}>{children}</Link>
    ) : (
      <a
        href={to}
        target={!sameTab ? `_blank` : `_self`}
        rel={!sameTab ? `noopener noreferrer` : ``}
      >
        {children}
      </a>
    )}
  </LinkOrAWrapper>
)

export default LinkOrA
